
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensaries/[[...location]]",
      function () {
        return require("private-next-pages/dispensaries/[[...location]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensaries/[[...location]]"])
      });
    }
  